<template>
	<v-list-tile dense @click="select">
		<v-layout>
			<v-flex xs4 class="text--secondary">{{ item.date | toShortDate }}</v-flex>
			<v-flex grow class="ml-2 text-truncate">{{ item.city }}</v-flex>
			<v-flex shrink class="hidden-xs-only">
				<v-rating dense small readonly :value="item.rating" color="yellow darken-1" background-color="grey lighten-1" />
			</v-flex>
		</v-layout>
	</v-list-tile>
</template>

<script>
import { toShortDate } from '@/utils/formatters';

export default {
	name: 'feedback-summary',
	props: {
		item: Object,
	},
	filters: { toShortDate },
	methods: {
		select() {
			this.$emit('select', this.item);
		}
	}
}
</script>
